export default[
    {
        name: 'AllNews',
        path: 'AllNews',
        component: () => import('@/pages/IndustryNews/AllNews'),
        meta: { title: '全部 ' },
        // props值为函数，该函数返回的对象中每一组key-value都会通过props传给Detail组件
        props(route) {
            return {
                id: route.query.id,
            }
        },
        children: [
            {
                name: 'NewsDetail-AllNews',
                path: 'NewsDetail',
                component: () => import('@/pages/IndustryNews/NewsDetail'),
                meta: { title: '全部-详情' },
                // props值为函数，该函数返回的对象中每一组key-value都会通过props传给Detail组件
                props(route) {
                    return {
                        id: route.query.id,
                    }
                },
            }
        ]
    },
    {
        name: 'SectorNews',
        path: 'SectorNews',
        component: () => import('@/pages/IndustryNews/SectorNews'),
        meta: { title: '行业新闻' },
        // props值为函数，该函数返回的对象中每一组key-value都会通过props传给Detail组件
        props(route) {
            return {
                id: route.query.id,
            }
        },
        children: [
            {
                name: 'NewsDetail-SectorNews',
                path: 'NewsDetail',
                component: () => import('@/pages/IndustryNews/NewsDetail'),
                meta: { title: '行业新闻-详情' },
                // props值为函数，该函数返回的对象中每一组key-value都会通过props传给Detail组件
                props(route) {
                    return {
                        id: route.query.id,
                    }
                },
            }
        ]
    },
    {
        name: 'CompanyNews',
        path: 'CompanyNews',
        component: () => import('@/pages/IndustryNews/CompanyNews'),
        meta: { title: '公司动态' },
        // props值为函数，该函数返回的对象中每一组key-value都会通过props传给Detail组件
        props(route) {
            return {
                id: route.query.id,
            }
        },
        children: [
            {
                name: 'NewsDetail-CompanyNews',
                path: 'NewsDetail',
                component: () => import('@/pages/IndustryNews/NewsDetail'),
                meta: { title: '公司动态-详情' },
                // props值为函数，该函数返回的对象中每一组key-value都会通过props传给Detail组件
                props(route) {
                    return {
                        id: route.query.id,
                    }
                },
            }
        ]
    },
    {
        name: 'KnowledgeSharing',
        path: 'KnowledgeSharing',
        component: () => import('@/pages/IndustryNews/KnowledgeSharing'),
        meta: { title: '知识分享' },
        // props值为函数，该函数返回的对象中每一组key-value都会通过props传给Detail组件
        props(route) {
            return {
                id: route.query.id,
            }
        },
        children: [
            {
                name: 'NewsDetail-KnowledgeSharing',
                path: 'NewsDetail',
                component: () => import('@/pages/IndustryNews/NewsDetail'),
                meta: { title: '知识分享-详情' },
                // props值为函数，该函数返回的对象中每一组key-value都会通过props传给Detail组件
                props(route) {
                    return {
                        id: route.query.id,
                    }
                },
            },
            {
                name: 'ProoUse',
                path: 'ProoUse',
                component: () => import('@/pages/IndustryNews/ProoUse'),
                meta: { title: '知识分享-使用证明示例' },
                // props值为函数，该函数返回的对象中每一组key-value都会通过props传给Detail组件
                props(route) {
                    return {
                        id: route.query.id,
                    }
                },
            }
        ]
    },

]